import React from "react";
import {
  VenueOffersPage,
} from "@zillout/shared-components";
import { useParams } from "react-router-dom";
import { env } from "../config/env";

export default function OffersPage() {
  const { pub_id } = useParams<{ pub_id: string }>();
  const placeId = pub_id || env.REACT_APP_PLACE_ID;

  return <VenueOffersPage pubId={placeId} />;
}
